import styled from '@emotion/styled';
import { getLinkPropsForUrl } from '../../../navigation/getLinkPropsForUrl';
import { RouterLink } from '../link/RouterLink';
import { Css, ITheme, IUrlLinkItem, Responsive } from '../../../ui';

export interface IFooterFeaturedLinkProps {
	link: IUrlLinkItem;
}

export function FooterFeaturedLink({ link }: IFooterFeaturedLinkProps) {
	return (
		<FooterFeaturedLinkWrap>
			<RouterLink {...getLinkPropsForUrl(link.url)}>{link.title}</RouterLink>
		</FooterFeaturedLinkWrap>
	);
}

const FooterFeaturedLinkWrap = styled.div<{}, ITheme>`
	a {
		font-family: ${(props) =>
			props.theme.typography.subheading.font.fontFamily};
		font-weight: ${(props) =>
			props.theme.typography.subheading.font.fontWeight};
		font-size: ${Css.pxToRem(24)};
		line-height: 1.2;
		text-decoration: none;
		color: ${(props) => props.theme.color.onSecondary};

		&:hover {
			text-decoration: underline;
			color: ${(props) => props.theme.color.onSecondary};
		}
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		a {
			font-size: ${Css.pxToRem(20)};
		}
	}
`;
